import React, { useState, useEffect } from 'react';
import Header from '../../components/admin/common/Header';
import Footer from '../../components/common/Footer';
import { Link } from 'react-router-dom';
import arrow_back from '../../assets/icons/arrow-back.svg'
import { Helmet } from 'react-helmet';
import PageTitle from './../../components/user/common/PageTitle';
import axios from 'axios';
import { toast } from 'react-toastify';
import SpinnerLoader from '../../components/common/SpinnerLoader';

const SupportAdmin = () => {
    const [supportText, setSupportText] = useState('');
    const [editMode, setEditMode] = useState(false);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        fetchSupportText();
    }, []);

    const fetchSupportText = async () => {
        try {
            const authInfo = JSON.parse(localStorage.getItem('authInfo'));
            const response = await axios.get('/admin/support-text', {
                headers: {
                    'Authorization': `Bearer ${authInfo.token}`
                }
            });

            if (response.data.status) {
                setSupportText(response.data.data);
            }
        } catch (error) {
            console.error('Error fetching support text:', error);
        } finally {
            setLoading(false);
        }
    };

    const handleSave = async () => {
        try {
            setLoading(true);
            const authInfo = JSON.parse(localStorage.getItem('authInfo'));
            const response = await axios.put('/admin/support-text',
                { supportText },
                {
                    headers: {
                        'Authorization': `Bearer ${authInfo.token}`
                    }
                }
            );

            if (response.data.status) {
                toast.success('Support text updated successfully!');
                setEditMode(false);
            } else {
                toast.error('Failed to update support text');
            }
        } catch (error) {
            toast.error('Error updating support text');
            console.error('Error:', error);
        } finally {
            setLoading(false);
        }
    };

    return (
        <React.Fragment>
            {loading && <SpinnerLoader />}
            <Header />
            <PageTitle title="Manage Support" />
            <Helmet><title>{"Admin - Manage Support - Pay Earth"}</title></Helmet>
            <section className="admin-dashboard-wrapper">
                <div className="inr_wrap dash_inner_wrap support_manager_wrapper">
                    <div className="col-md-12">
                        <div className="seller_dash_wrap pt-2 pb-5">
                            <div className="container ">
                                <div className="bg-white rounded-3 pt-3 pb-5">
                                    <div className="noti_wrap">
                                        <div className='d-flex justify-content-end'><span>
                                            <button
                                                type="button"
                                                className="btn custum_back_btn btn_yellow mx-auto me-4"
                                                onClick={() => window.history.back()}
                                            >
                                                <img src={arrow_back} alt="back" />&nbsp;
                                                Back
                                            </button>
                                        </span></div>
                                    </div>
                                    <div className="dash_inner_wrap">

                                        <div className="col-md-12">
                                            <div className="bg-light rounded-3 p-4 mb-4">
                                                <h4 className="mb-3 text-dark">Edit Support Description</h4>
                                                {editMode ? (
                                                    <div>
                                                        <textarea
                                                            className="form-control mb-3"
                                                            rows="3"
                                                            value={supportText}
                                                            style={{ height: '150px' }}
                                                            onChange={(e) => setSupportText(e.target.value)}
                                                        />
                                                        <button
                                                            className="btn custom_btn btn_yellow me-2"
                                                            onClick={handleSave}
                                                        >
                                                            Save
                                                        </button>
                                                        <button
                                                            className="btn btn-secondary"
                                                            onClick={() => {
                                                                setEditMode(false);
                                                                fetchSupportText();
                                                            }}
                                                        >
                                                            Cancel
                                                        </button>
                                                    </div>
                                                ) : (
                                                    <div>
                                                        <p className="mb-3">{supportText}</p>
                                                        <button
                                                            className="btn custom_btn btn_yellow"
                                                            onClick={() => setEditMode(true)}
                                                        >
                                                            Edit
                                                        </button>
                                                    </div>
                                                )}
                                            </div>

                                            <div className="support_head_panel">
                                                <h2>Quick Customer Support</h2>
                                                <p>{supportText}</p>

                                                <div className="support_button">
                                                    <a className="btn custom_btn btn_yellow mx-auto" href="https://mail.google.com/" target="_blank" rel="noopener noreferrer" id="email">Check Email's</a>
                                                    <Link className="btn custom_btn btn_yellow mx-auto" to="/admin/support-call" id="call" >Check request a call</Link>
                                                    <Link className="btn custom_btn btn_yellow mx-auto" to="/admin/chat">Chat</Link>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <Footer />
        </React.Fragment>
    );
}

export default SupportAdmin;
